import Api from './api'

const urlPath = "resources"

export default {
    //GET
    list: (params = {}) => Api.GET(urlPath, params),

    //POST
    addResource: (json) => Api.POST(`${urlPath}?resource=${json.resource}`, json),

    //PUT
    updateResource: (json) => Api.PUT(`${urlPath}/${json.id}?resource=${json.resource}`, json),
}